import { alertCircle, checkmarkCircle, closeCircle, pauseCircle } from 'ionicons/icons';
import { ISubscription } from '../redux/subscriptions/types';
import { DateTime } from 'luxon';
import { TFunction } from 'i18next';

export type SubscriptionStatusType = {
  text: string;
  icon: string;
  status: 'active' | 'pause' | 'expiring-soon' | 'cancel';
};

export const getPlanStatus = (subscription: ISubscription | null, t: TFunction): SubscriptionStatusType => {
  if (!subscription) return { text: '', icon: checkmarkCircle, status: 'cancel' };

  const isSubscriptionPause = subscription?.subscription_status === 'active' && subscription.pause_collection;
  const isSubscriptionActive = subscription?.subscription_status === 'active' && !subscription.cancel_at_period_end;
  const daysToPeriodEnd = Math.floor(DateTime.fromSeconds(subscription.period_end).diffNow('days').days);

  const formattedEndDate = DateTime.fromSeconds(subscription.period_end).toFormat('dd.MM');

  if (isSubscriptionPause) {
    return {
      text: t('subscriptions.subscriptionStatus.paused'),
      icon: pauseCircle,
      status: 'pause',
    };
  } else if (isSubscriptionActive && daysToPeriodEnd <= 7) {
    return {
      text: t('subscriptions.subscriptionStatus.renewalNotice', {
        date: formattedEndDate,
      }),
      icon: alertCircle,
      status: 'expiring-soon',
    };
  } else if (isSubscriptionActive) {
    return {
      text: t('subscriptions.subscriptionStatus.active'),
      icon: checkmarkCircle,
      status: 'active',
    };
  } else {
    return {
      text: t('subscriptions.subscriptionStatus.validUntil', {
        date: formattedEndDate,
      }),
      icon: closeCircle,
      status: 'cancel',
    };
  }
};
